import FansHeader from '@/components/fans/header';
import { Footer} from "@/components/common/index.js"
import DMessage from '@/components/3d/d-message';
import SwiperWinPrize from '@/components/common/swiper/swiper-win-prize'
import DemandWriteDialog from "@/components/fans/demand-write-dialog";
import DemandWriteSuccessDialog from "@/components/fans/demand-write-dialog/success-dialog";
import ReminderDialog from '@/components/common/dialog/ reminder-dialog'
import {fnRouter} from "~/fn";
import {PAGE_PATH} from "~/constant/PAGE_PATH";

let mixin = {

  components: {
    FansHeader,
    Footer,
    DMessage,
    SwiperWinPrize,
    DemandWriteDialog,
    DemandWriteSuccessDialog,
    ReminderDialog
  },

  data(){
    return{
    }
  },
  methods:{
    btnClick(){
      this.$refs.ReminderDialog.isShow = false;
      fnRouter.navigationTo('/pay/1','_blank', true);
    }
  }
}

export default mixin;
